import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const StorefrontProductSelectors = {
  ...createBasicSelectors('storefrontProduct'),
}

export default StorefrontProductSelectors
